
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HighlightsSection from './components/HighlightsSection';
import ServicesSection from './components/ServicesSection';
import CertificateSection from './components/CertificateSection';
import AboutSection from './components/AboutSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import ScheduleSection from './components/ScheduleSection';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <HighlightsSection />
        <ServicesSection />
        <ProcessSection />
        <CertificateSection />
        <AboutSection />
        <FAQSection />
        <CTASection />
        <ScheduleSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
